import Const from 'constants';
import {generateSignature} from 'helpers/hash';

const defaultStateData = {
    teamOptions: {},
};

const defaultState = {
    data: cp(defaultStateData),
    defaultTeamOptionsEnabledStatus: true,
    enabled: true,
    widgetHidden: true,
    signature: null,
    all() {
        return {...this.data};
    },
    getItems() {
        return Object.values(this.data.teamOptions);
    },
    hasItems() {
        return !isEmpty(this.data.teamOptions);
    },
    getItem(teamName) {
        return this.data.teamOptions[teamName];
    },
    getTeamOptions() {
        return this.data.teamOptions;
    },
    isEnabled() {
        return Boolean(this.enabled);
    },
    isWidgetHidden() {
        return Boolean(this.widgetHidden);
    },
    getDefaultTeamOptionsEnabledStatus() {
        return this.defaultTeamOptionsEnabledStatus;
    },
    getSignature() {
        return this.signature;
    },
};

export default function (state = defaultState, action) {
    state = {...state};

    if (action.type === Const.TEAM_NAME_STACKING_SET_DATA_FROM_STORAGE) {
        state.data = action.data;
        state.data.teamOptions ??= {};
    } else if (action.type === Const.TEAM_NAME_STACKING_SET_TEAM_OPTIONS) {
        state.data.teamOptions[action.data.teamName] = action.data.teamOptions;
    } else if (action.type === Const.TEAM_NAME_STACKING_SET_ALL_TEAM_OPTIONS_ENABLED_STATUS) {
        const isEnabled = action.isEnabled;

        state.defaultTeamOptionsEnabledStatus = isEnabled;
        Object.keys(state.data.teamOptions).map((teamName) => {
            state.data.teamOptions[teamName].enabled = isEnabled;
        });
    } else if (action.type === Const.TEAM_NAME_STACKING_SET_MAX_PLAYERS_FOR_TEAMS) {
        const maxPlayersForTeams = action.maxPlayersForTeams;

        action.teamNames.map((teamName) => {
            if (!isEmpty(state.data.teamOptions[teamName])) {
                state.data.teamOptions[teamName].maxPlayers = maxPlayersForTeams;
                if (state.data.teamOptions[teamName].minPlayers > state.data.teamOptions[teamName].maxPlayers) {
                    state.data.teamOptions[teamName].minPlayers = 0;
                }
            } else {
                state.data.teamOptions[teamName] = {
                    enabled: state.getDefaultTeamOptionsEnabledStatus(),
                    minPlayers: 0,
                    maxPlayers: maxPlayersForTeams,
                };
            }
        });
    } else if (action.type === Const.TEAM_NAME_STACKING_SET_IS_USED) {
        state.enabled = Boolean(action.use);
    } else if (action.type === Const.TEAM_NAME_STACKING_SET_IS_WIDGET_HIDDEN) {
        state.widgetHidden = Boolean(action.hidden);
    } else if (action.type === Const.CORRELATION_STACKING_SET_IS_USED) {
        if (Boolean(action.use)) {
            state.enabled = false;
            state.widgetHidden = true;
        }
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {
            ...defaultState,
            data: cp(defaultStateData),
            enabled: true,
            widgetHidden: true,
            signature: generateSignature(),
        };
    }

    return state;
}
